import { Link } from 'react-router-dom';

interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
  count: number;
  imageSeq: string;
}

interface CategoryCardProps {
  category: Category;
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${category.slug}`}
      className="group bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer flex flex-col items-center text-center"
    >
      <div className="w-14 h-14 rounded-full bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className={`${category.icon} text-xl text-primary-500 group-hover:text-primary-600 transition-colors`}></i>
        </div>
      </div>
      <h3 className="mt-3 text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
        {category.name}
      </h3>
      <p className="mt-1 text-xs text-foreground-500">
        {category.count.toLocaleString()} 家企业
      </p>
    </Link>
  );
}